(function () {
  angular.module('7Shop.Common')
    .filter('sTrustAs', function sTrustAs($sce) {
      return function (input, type) {
        return $sce.trustAs(type, input);
      };
    });
})();
